import {Action} from 'redux'
import {
  AuctionImageTypeListModel,
  AuctionModel,
  AuctionTypeModel,
  DynamicComponentModel,
  PropertyTypeListModel,
} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialAuctionState: IDynamicComponentState = {
  data: {
    dynamicComponent: [],
    meta: [],
  },
  sortAuctionData: [],
  auctionList: {auction: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IDynamicComponentState {
  data?: {
    dynamicComponent?: DynamicComponentModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortAuctionData?: IDynamicComponentState[]
  auctionList?: {auction: AuctionModel[]}
  auctionTypeList?: {auctionType: AuctionTypeModel[]}
  propertyTypeList?: {propertyType: PropertyTypeListModel[]}
  auctionImageTypeList?: {auctionImageType: AuctionImageTypeListModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IDynamicComponentState = initialAuctionState,
  action: ActionWithPayload<IDynamicComponentState>
) => {
  switch (action.type) {
    //GET  DATA dynamic compoent
    case actionTypes.GET_DYNAMIC_COMPONENT_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_DYNAMIC_COMPONENT_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_DYNAMIC_COMPONENT_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add  AbroadRepresentativesModel
    case actionTypes.ADD_DYNAMIC_COMPONENT_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_DYNAMIC_COMPONENT_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_DYNAMIC_COMPONENT_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_DYNAMIC_COMPONENT: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update  DYNAMIC_COMPONENT
    case actionTypes.UPDATE_DYNAMIC_COMPONENT_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_DYNAMIC_COMPONENT_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_DYNAMIC_COMPONENT_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete AbroadRepresentativesModel
    case actionTypes.DELETE_DYNAMIC_COMPONENT_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_DYNAMIC_COMPONENT_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_DYNAMIC_COMPONENT_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    // auction start here

    //GET Auction DATA
    case actionTypes.GET_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AUCTION_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add Auction
    case actionTypes.ADD_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_AUCTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_AUCTION: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update Auction
    case actionTypes.UPDATE_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_AUCTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_AUCTION_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_AUCTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_AUCTION_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_AUCTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_AUCTION_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_AUCTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_AUCTION_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_AUCTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_AUCTION_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_AUCTION_SUCCESS: {
      return {
        ...state,
        sortAuctionData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_AUCTION_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortAuctionData: [],
      }
    }
    // AUCTION TYPE
    case actionTypes.GET_AUCTION_TYPE_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AUCTION_TYPE_LIST_SUCCESS: {
      return {...state, auctionTypeList: action.payload, loading: false}
    }

    case actionTypes.GET_AUCTION_TYPE_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // PROPERTY TYPE
    case actionTypes.GET_PROPERTY_TYPE_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_PROPERTY_TYPE_LIST_SUCCESS: {
      return {...state, propertyTypeList: action.payload, loading: false}
    }

    case actionTypes.GET_PROPERTY_TYPE_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // AUCTION_IMAGE TYPE
    case actionTypes.GET_AUCTION_IMAGE_TYPE_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AUCTION_IMAGE_TYPE_LIST_SUCCESS: {
      return {...state, auctionImageTypeList: action.payload, loading: false}
    }

    case actionTypes.GET_AUCTION_IMAGE_TYPE_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    default:
      return state
  }
}
